
// We use 'any' for window here to avoid strict type checking on the custom property 'deferredPrompt' 
// without needing a complex global type declaration file in this setup.
const win = window as any;

const listeners: Array<(available: boolean) => void> = [];

// 1. Listen for the custom event dispatched by index.html
if (typeof window !== 'undefined') {
  window.addEventListener('pwa-install-ready', () => {
    console.log("PWA Service: Recieved pwa-install-ready event.");
    notifyListeners(true);
  });

  window.addEventListener('appinstalled', () => {
    win.deferredPrompt = null;
    notifyListeners(false);
    console.log("PWA Installed successfully.");
  });
}

const notifyListeners = (available: boolean) => {
    listeners.forEach(listener => listener(available));
};

// 2. Allow React components to subscribe to the status
export const onInstallAvailabilityChange = (callback: (available: boolean) => void) => {
  listeners.push(callback);
  
  // Check immediate state from the global window property
  if (win.deferredPrompt) {
      callback(true);
  } else {
      callback(false);
  }

  // Return unsubscribe function
  return () => {
    const index = listeners.indexOf(callback);
    if (index > -1) listeners.splice(index, 1);
  };
};

export const installPWA = async () => {
  const promptEvent = win.deferredPrompt;
  if (!promptEvent) {
      console.warn("No install prompt available in global state.");
      return false;
  }
  
  // Show the install prompt
  promptEvent.prompt();
  
  // Wait for the user to respond to the prompt
  const { outcome } = await promptEvent.userChoice;
  console.log(`User response to the install prompt: ${outcome}`);
  
  // We've used the prompt, and can't use it again, throw it away
  win.deferredPrompt = null;
  notifyListeners(false);
  
  return outcome === 'accepted';
};

export const isStandalone = () => {
  const isStandalone = (window.matchMedia('(display-mode: standalone)').matches) || 
                       ((window.navigator as any).standalone === true);
  return isStandalone;
};

export const requestPersistence = async () => {
    if (navigator.storage && navigator.storage.persist) {
        const isPersisted = await navigator.storage.persisted();
        if (!isPersisted) {
            await navigator.storage.persist();
            console.log("Storage persistence requested");
        }
    }
};
